var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_7849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4562 19.0711C18.6262 19.2411 18.9014 19.2408 19.0711 19.0711C19.2408 18.9014 19.2411 18.6262 19.0711 18.4562L12.6149 12L19.0711 5.54381C19.2411 5.3738 19.2408 5.09864 19.0711 4.92893C18.9014 4.75923 18.6262 4.75892 18.4562 4.92893L12 11.3851L5.54385 4.92893C5.37415 4.75923 5.09868 4.75923 4.92898 4.92893C4.75927 5.09864 4.75927 5.3741 4.92898 5.54381L11.3852 12L4.92898 18.4562C4.75927 18.6259 4.75927 18.9014 4.92898 19.0711C5.09868 19.2408 5.37415 19.2408 5.54385 19.0711L12 12.6149L18.4562 19.0711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_7849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/iconCross.2619540909850b7ab9cbc4346f444df9.svg";
export { ForwardRef as ReactComponent };